const getters = {
    openedMobileMenu(state) {
        return state.openedMobileMenu;
    }
};

export default getters;